<template>
    <b-modal id="client_family" ref="client_family" @hidden="resetModal"
             :header-class="{'no-border': mode === 'delete'}" :footer-class="{'no-border' : mode === 'delete'}">

        <template v-slot:modal-title>
            <div v-if="mode === 'add'">
                Add Family Member
            </div>

            <div v-if="mode === 'delete'">
                Delete {{member ? member.data.attributes.name : ''}}
            </div>
        </template>

        <div v-if="mode === 'add'" class="mb-4">
            Adding a family members means adding a family member. If you are confused, add a family member.
            By doing so, you'll successfully add a family member. Hope everything is clear now!
        </div>

        <div v-if="mode === 'delete'">
            You can't revert back your action if you unassign this user. For further query, contact Database Manager!
        </div>

        <b-form v-if="mode === 'add'">
            <b-row>
                <b-colxx md="8">
                    <b-form-group label="Name" class="has-float-label">
                        <template v-slot:label>
                            <span>Name <sup><code>*</code></sup></span>
                        </template>
                        <b-form-input type="text" v-model="form.name" :class="{'border-danger': 'name' in errors}"
                                      @input="'name' in errors ? (delete errors.name) : ''"
                                      autocomplete="off" placeholder="Full Name"/>

                        <b-form-invalid-feedback :state="!('name' in errors)"
                                                 v-text="'name' in errors ? errors.name[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="4">
                    <b-form-group label="Gender" class="has-float-label">
                        <template v-slot:label>
                            <span>Gender <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateGender" v-model="selected.gender" :options="genders"
                                  :border-danger="'gender' in errors"/>

                        <b-form-invalid-feedback :state="!'gender' in errors"
                                                 v-text="'gender' in errors ? errors.gender[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group class="mb-4">
                        <b-form-file v-model="image" placeholder="Choose a picture..."/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="6">
                    <b-form-group label="Type" class="has-float-label">
                        <template v-slot:label>
                            <span>Type <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateType" v-model="selected.type" :options="types"
                                  :border-danger="'type' in errors"/>

                        <b-form-invalid-feedback :state="!'type' in errors"
                                                 v-text="'type' in errors ? errors.type[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group label="Relation" class="has-float-label">
                        <b-form-input type="text" v-model="form.relation" autocomplete="off" placeholder="Relation"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="6">
                    <b-form-group label="SSN" class="has-float-label">
                        <b-form-input type="text" v-model="form.ssn" v-mask="'###-##-####'" autocomplete="off" placeholder="XXX-XX-XXX"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group label="Date of Birth" class="has-float-label">
                        <template v-slot:label>
                            <span>Date of Birth <sup><code>*</code></sup></span>
                        </template>

                        <v-date-picker
                            popover-visibility="focus" mode="single"
                            v-model="datepicker.dob"
                            @input="'dob' in errors ? delete errors.dob : ''"
                            :input-props="{ class:'form-control' + ('dob' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                        <b-form-invalid-feedback :state="!'dob' in errors"
                                                 v-text="'dob' in errors ? errors.dob[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>



        </b-form>

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('client_family')" v-text="'Cancel'"/>

            <state-button v-if="mode === 'add'" size="sm" variant="primary" :click="submitFamily">Submit</state-button>
            <state-button v-if="mode === 'delete'" size="sm" variant="danger" :click="deleteFamily">Unassign</state-button>
        </template>
    </b-modal>
</template>

<script>
    import {mapGetters} from 'vuex';
    import StateButton from "../../../../../components/Common/StateButton";
    import moment from "moment";

    export default {
        name: "ClientFamilyModal",

        components: {
            StateButton,
        },

        props: [
            'client', 'member', 'mode'
        ],

        data() {
            return {
                genders: [
                    {label: 'Male', value: 'Male'},
                    {label: 'Female', value: 'Female'},
                    {label: 'Other', value: 'Other'},
                ],
                types: [
                    {label: 'Adult', value: 'Adult'},
                    {label: 'Children', value: 'Children'},
                ],
                datepicker: {
                    dob: null,
                },
                selected: {
                    gender: [],
                    type: [],
                },
                image: null,
            }
        },

        computed: {
            ...mapGetters({
                form: 'getClientFamilyForm',
                staff: 'getSelectUsers',
                errors: 'getClientErrors',
            }),
        },

        watch: {
            'datepicker.dob'(date) {
                if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.dob = null;
                this.form.dob = moment(date).format('YYYY-MM-DD');
            },
        },

        methods: {
            updateGender(field) {
                if (field) {
                    this.form.gender = field.value;
                } else {
                    this.form.gender = '';
                }
                'gender' in this.errors ? delete this.errors.gender : '';
            },

            updateType(field) {
                if (field) {
                    this.form.type = field.value;
                } else {
                    this.form.type = '';
                }
                'type' in this.errors ? delete this.errors.type : '';
            },

            submitFamily() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('submitClientFamily', this.form)
                        .then(response => {
                            this.uploadImage(response.data);
                        })
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('updated');

                                this.$notify('success filled', 'Success!', 'Added new family member!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('client_family');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },

            deleteFamily() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('deleteClientFamily', this.member)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('updated');

                                this.$notify('warning filled', 'Success!', 'Deleted ' + this.member.data.attributes.name + '!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('client_family');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },

            uploadImage(member) {
                if (this.image) {
                    let image = new FormData();
                    image.append('image', this.image);

                    axios.post('/api/hms/clients/list/' + this.client.client_id + '/family/' + member.member_id +'/image', image)
                        .catch(error => {
                            console.log(error);
                        });
                }
            },

            resetModal() {
                this.$store.commit('setClientFamilyForm');

                this.datepicker =  {
                    dob: null,
                };

                this.selected = {
                    gender: [],
                    type: [],
                };

                this.image = null;
            },

            hideModal(refname) {
                this.$refs[refname].hide();
            },
        },
    }
</script>

<style scoped>

</style>
